import classNames from 'classnames';
import { action, makeObservable } from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {X9Content, X9ContentSnapshot} from '../../../../../domain';
import {ReactFlipper} from '../../../../../lib/components';
import {ReactNodeGenerator} from '../../../../../lib/helpers';
import {X9ContentStateStore} from '../../common/X9ContentStateStore';
import {FlashcardSide, FlashcardsModel} from '../models';
import {FlashcardsStore} from './FlashcardsStore';

class FlashcardSideView extends React.Component<{ store: FlashcardsStore, side: FlashcardSide, index: number }> {
  readonly audioElementRef = React.createRef<HTMLAudioElement>();

  @action
  toggle = () => {
    this.props.store.toggle(this.props.index);
  };

  playAudio = (event: React.MouseEvent) => {
    event.stopPropagation();
    const audioElement = this.audioElementRef.current;
    if (audioElement === null)
      return;
    audioElement.play();
  };

  constructor(props: { store: FlashcardsStore, side: FlashcardSide, index: number }) {
    super(props);
    makeObservable(this);
  }

  render() {
    const {side} = this.props;

    const hasText = side.text !== null;
    const hasImage = side.image !== null;
    const hasAudio = side.audio !== null;
    const classname = classNames('flashcard-side',
      {
        'has-image': hasImage,
        'has-no-image': !hasImage,
        'has-text': hasText,
        'has-no-text': !hasText,
        'has-audio': hasAudio,
        'has-no-audio': !hasAudio
      });
    return (
      <div className={classname} onClick={this.toggle}>
        {
          side.image !== null &&
          // <div className="flashcard-image-wrapper"
              //  style={{backgroundImage: `url(${side.image})`}}/>
              <div className="flashcard-image-wrapper">
                <img src={side.image} alt="Image not found" />
              </div>
        }

        <div className="flashcard-bottom">
          {
            side.text !== null &&
            <div className="flashcard-text-wrapper">
              <div className="flashcard-text">
                {side.text}
              </div>
            </div>
          }

          {
            side.audio !== null &&
            <div className="flashcard-audio-wrapper">
              <audio ref={this.audioElementRef} src={side.audio} preload="auto"/>
              <button type="button" className="flashcard-audio-button btn btn-light"
                      onClick={this.playAudio}><i className="fas fa-volume-up"/>
              </button>
            </div>
          }
        </div>
      </div>);
  }
}

@observer
class FlashcardView extends React.Component<{ index: number; store: FlashcardsStore }> {
  render() {
    const {index, store} = this.props;
    const {front, back} = store.model.cards[index];
    const flipper = store.flippers[index];

    return (
      <div className="col-auto">
        <div className="flashcard">
          <ReactFlipper store={flipper}>
            <FlashcardSideView side={front} index={index} store={store}/>
            <FlashcardSideView side={back} index={index} store={store}/>
          </ReactFlipper>
        </div>
      </div>);
  }
}


function* renderer(store: FlashcardsStore): ReactNodeGenerator {
  const length = store.model.cards.length;

  for (let index = 0; index < length; index++) {
    yield (<FlashcardView store={store} index={index} key={index}/>);
  }
}

interface Props {
  x9: X9Content | X9ContentSnapshot,
  store: X9ContentStateStore
}

@observer
export class TeacherFlashcards extends React.Component<Props> {
  readonly store: FlashcardsStore;

  constructor(props: Readonly<Props>) {
    super(props);
    const model = JSON.parse(this.props.x9.Contents) as FlashcardsModel;
    this.store = new FlashcardsStore(props.x9.Id, model, props.store);
  }

  render() {
    return (<div className="row">
      {Array.from(renderer(this.store))}
    </div>);
  }

  componentWillUnmount() {
    this.store.dispose();
  }
}
